import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
import React from "react";
import { graphql, useFragment, type FragmentType } from "~/gql/runtime";
import { NavLink } from "~/features/app/app-header-v2/nav-links/nav-link";
import { NavDropdown } from "~/features/app/app-header-v2/nav-links/nav-dropdown";
import { hasItems } from "~/features/app/utils";
import { useNavLayout } from "~/features/app/app-header-v2/context";
import { useClickOutside } from "~/features/app/app-header-v2/nav-links/use-click-outside";
import { NavDropdownBackdrop } from "~/features/app/app-header-v2/nav-dropdown-backdrop";
const fragment = graphql(`
  fragment NavLinksV2 on navLinks_NeoField {
    __typename
    ...NavLink
    ...NavDropdownV2
  }
`);
type Props = {
  navLinks: FragmentType<typeof fragment>[];
};
const style = {
  transparent: {
    "borderColor": "rgba(255, 255, 255, 0.2)",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  },
  solid: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(239 239 246 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(0 7 4 / var(--tw-text-opacity))"
  },
  highlighted: {
    "borderColor": "rgb(0 7 4 / 0.1)",
    "backgroundColor": "var(--white-static)",
    "color": "var(--black-static)"
  }
};
export function NavLinks(props: Props) {
  const {
    navLinks
  } = props;
  const links = useFragment(fragment, navLinks);
  const {
    navTheme,
    isPageHighlighted,
    activeDropdown,
    setActiveDropdown
  } = useNavLayout();
  const surface = isPageHighlighted ? "highlighted" : navTheme;
  const linkTheme = isPageHighlighted ? "solid" : navTheme;
  const navRef = React.useRef<HTMLElement>(null);
  useClickOutside(navRef, () => {
    if (activeDropdown) {
      setActiveDropdown(null);
    }
  }, !!activeDropdown);
  if (!hasItems(links)) {
    return null;
  }
  return <_StyledDiv>
      <NavDropdownBackdrop />
      <_StyledNav ref={navRef} $_css={[{
      "pointerEvents": "auto",
      "position": "relative",
      "zIndex": "101",
      "display": "flex",
      "height": "var(--header-height)",
      "flex": "1 1 0%",
      "alignItems": "center",
      "borderBottomWidth": "1px",
      "fontSize": "1.6rem",
      "lineHeight": "1.5",
      "fontWeight": "400"
    }, style[surface]]}>
        <_StyledUl>
          {links.map((item, idx) => {
          if (item.__typename === "navLinks_link_BlockType") {
            return <_StyledLi key={idx}>
                  <_StyledNavLink theme={linkTheme} {...item} />
                </_StyledLi>;
          }
          if (item.__typename === "navLinks_dropdown_BlockType") {
            return <_StyledLi2 key={idx}>
                  <NavDropdown {...item} />
                </_StyledLi2>;
          }
          return null;
        })}
        </_StyledUl>
      </_StyledNav>
    </_StyledDiv>;
}
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-cdfr6t-0"
})({
  "position": "relative"
});
var _StyledNav = _styled2("nav").withConfig({
  componentId: "sc-sf-cdfr6t-1"
})`${p => p.$_css}`;
var _StyledUl = _styled3("ul").withConfig({
  componentId: "sc-sf-cdfr6t-2"
})({
  "display": "flex",
  "height": "100%"
});
var _StyledLi = _styled4("li").withConfig({
  componentId: "sc-sf-cdfr6t-3"
})({
  "position": "relative",
  "height": "100%"
});
var _StyledNavLink = _styled5(NavLink).withConfig({
  componentId: "sc-sf-cdfr6t-4"
})({
  "paddingLeft": "5.2rem",
  "paddingRight": "5.2rem"
});
var _StyledLi2 = /*#__PURE__*/_styled6("li").withConfig({
  displayName: "nav-links___StyledLi2",
  componentId: "sc-4gd2mj-0"
})({
  "display": "flex",
  "height": "100%",
  "alignItems": "center"
});